import { CSSProperties } from "react";
import { C, Chip, WidgetBox } from "./ui";
import { WidgetProps } from "./windows";

// Option solver box of the agent's solve_option (rflx-backend ibkr_agent.py):
// every Black-Scholes input and the solved value (highlighted). Read-only.
// params: {solveFor, right, underlying, strike, volatility, rate, time,
// timeUnits, expiry?, price, label?, result | error}
const UNITS: Record<string, string> = { d: "days", h: "hours", y: "years" };

const num = (v: number | null | undefined, digits = 3) => (v == null ? "—" : String(Number(v.toFixed(digits))));
const pct = (v: number | null | undefined, digits = 2) => (v == null ? "—" : `${Number((v * 100).toFixed(digits))}%`);

export function SolverWidget({ widget, actions }: WidgetProps) {
  const p = widget.params;
  // "8.25 days" (the solver counts to 16:00 New York on the expiry date)
  const time = p.time == null ? "—" : `${p.time.toFixed(2)} ${UNITS[p.timeUnits] ?? p.timeUnits}`;
  const rows: [string, string, string][] = [
    ["right", "Type", p.right === "C" ? "Call" : "Put"],
    ["underlying", "Underlying", num(p.underlying)],
    ["strike", "Strike", num(p.strike)],
    ["volatility", "Volatility", pct(p.volatility, 1)],
    ["rate", "Rate", pct(p.rate)],
    ["time", "Time to expiry", time],
    ["price", "Option price", num(p.price)],
  ];
  // explicit borders / margin: the app's global table styles add a grid and a top margin
  const cell: CSSProperties = { padding: "3px 10px", border: 0, borderBottom: `1px solid ${C.divider}` };

  return (
    <WidgetBox
      title={<span>Option solver{p.label ? <> <Chip>{p.label}</Chip></> : null}</span>}
      status={p.error ? <span style={{ color: C.cancelled }}>no solution</span> : undefined}
      onClose={actions.close}
    >
      <table style={{ width: "100%", margin: 0, borderCollapse: "collapse", fontSize: 12.5 }}>
        <tbody>
          {rows.map(([key, label, value]) => {
            const solved = key === p.solveFor;
            return (
              <tr key={key} style={{ background: solved ? C.selected : undefined, fontWeight: solved ? 600 : 400 }}>
                <td style={{ ...cell, color: solved ? C.text : C.muted, width: "40%" }}>{label}{solved ? " (solved)" : ""}</td>
                <td style={{ ...cell, textAlign: "right" }}>{solved && p.error ? "—" : value}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {p.error && <div style={{ padding: "6px 10px", color: C.cancelled, overflowWrap: "anywhere" }}>{p.error}</div>}
    </WidgetBox>
  );
}
